import AllbirdsByNature from './AllbirdsByNature';
import AllbirdsLogo from './AllbirdsLogo';
import AmazonPay from './AmazonPay';
import ApplePay from './ApplePay';
import Download from './Download';
import Filters from './Filters';
import GooglePay from './GooglePay';
import Help from './Help';
import Info from './Info';
import LinkOut from './LinkOut';
import NextCircle from './NextCircle';
import PayPal from './PayPal';
import Peace from './Peace';
import PlayTriangle from './PlayTriangle';
import PlayTriangleCircle from './PlayTriangleCircle';
import Search from './Search';
import SearchSkinny from './SearchSkinny';
import SearchWhite from './SearchWhite';
import ShopifyPay from './ShopifyPay';
import User from './User';
import ZoomCircle from './ZoomCircle';

const TYPES = {
  AllBIRDS_BY_NATURE: 'AllBIRDS_BY_NATURE',
  ALLBIRDS_LOGO: 'ALLBIRDS_LOGO',
  AMAZON_PAY: 'AMAZON_PAY',
  APPLE_PAY: 'APPLE_PAY',
  DOWNLOAD: 'DOWNLOAD',
  FILTERS: 'FILTERS',
  GOOGLE_PAY: 'GOOGLE_PAY',
  HELP: 'HELP',
  INFO: 'INFO',
  LINK_OUT: 'LINK_OUT',
  NEXT_CIRCLE: 'NEXT_CIRCLE',
  PAY_PAL: 'PAY_PAL',
  PEACE: 'PEACE',
  PLAY_TRIANGLE: 'PLAY_TRIANGLE',
  PLAY_TRIANGLE_CIRCLE: 'PLAY_TRIANGLE_CIRCLE',
  SEARCH: 'SEARCH',
  SEARCH_SKINNY: 'SEARCH_SKINNY',
  SEARCH_WHITE: 'SEARCH_WHITE',
  SHOPIFY_PAY: 'SHOPIFY_PAY',
  STAR_EMPTY: 'STAR_EMPTY',
  STAR_FULL: 'STAR_FULL',
  STAR_HALF: 'STAR_HALF',
  USER: 'USER',
  ZOOM_CIRCLE: 'ZOOM_CIRCLE',
};

const ICON_COMPONENT_MAP = {
  [TYPES.AllBIRDS_BY_NATURE]: AllbirdsByNature,
  [TYPES.ALLBIRDS_LOGO]: AllbirdsLogo,
  [TYPES.AMAZON_PAY]: AmazonPay,
  [TYPES.APPLE_PAY]: ApplePay,
  [TYPES.DOWNLOAD]: Download,
  [TYPES.FILTERS]: Filters,
  [TYPES.GOOGLE_PAY]: GooglePay,
  [TYPES.HELP]: Help,
  [TYPES.INFO]: Info,
  [TYPES.LINK_OUT]: LinkOut,
  [TYPES.NEXT_CIRCLE]: NextCircle,
  [TYPES.PAY_PAL]: PayPal,
  [TYPES.PEACE]: Peace,
  [TYPES.PLAY_TRIANGLE]: PlayTriangle,
  [TYPES.PLAY_TRIANGLE_CIRCLE]: PlayTriangleCircle,
  [TYPES.SEARCH]: Search,
  [TYPES.SEARCH_SKINNY]: SearchSkinny,
  [TYPES.SEARCH_WHITE]: SearchWhite,
  [TYPES.SHOPIFY_PAY]: ShopifyPay,
  [TYPES.USER]: User,
  [TYPES.ZOOM_CIRCLE]: ZoomCircle,
};

export { TYPES, ICON_COMPONENT_MAP };
